import React from 'react'
import ServiceTemplate from '../../components/ServiceTemplate'
import { RefreshCw, Database, Shield, CheckCircle } from 'lucide-react'

const OdooMigration = () => {
  const features = [
    {
      icon: <RefreshCw className="w-6 h-6" data-component-path="client/src/pages/services/OdooMigration.jsx" data-component-line="7:12" data-component-id="client/src/pages/services/OdooMigration.jsx:7:12" />,
      title: 'Version Upgrades',
      description: 'Seamless migration to latest Odoo versions'
    },
    {
      icon: <Database className="w-6 h-6" data-component-path="client/src/pages/services/OdooMigration.jsx" data-component-line="13:12" data-component-id="client/src/pages/services/OdooMigration.jsx:13:12" />,
      title: 'Data Integrity',
      description: 'Zero data loss during migration process'
    },
    {
      icon: <Shield className="w-6 h-6" data-component-path="client/src/pages/services/OdooMigration.jsx" data-component-line="19:12" data-component-id="client/src/pages/services/OdooMigration.jsx:19:12" />,
      title: 'Risk Mitigation',
      description: 'Comprehensive testing before go-live'
    },
    {
      icon: <CheckCircle className="w-6 h-6" data-component-path="client/src/pages/services/OdooMigration.jsx" data-component-line="25:12" data-component-id="client/src/pages/services/OdooMigration.jsx:25:12" />,
      title: 'Custom Module Updates',
      description: 'Adapt customizations to new versions'
    },
  ]

  return (
    <ServiceTemplate
      title="Odoo Migration"
      subtitle="Upgrade to the latest Odoo version with zero downtime"
      description="Stay current with Odoo's latest features and security updates through our expert migration services. We handle the entire process from planning to execution, ensuring your data, customizations, and workflows transition smoothly to the new version."
      features={features}
      heroImage="https://images.pexels.com/photos/4483610/pexels-photo-4483610.jpeg?auto=compress&cs=tinysrgb&w=1920"
    />
  )
}

export default OdooMigration